import { LhChange } from "@liebherr/patternlib";
import { PatternlibTextareaCustomEvent } from "@liebherr/patternlib/dist/types/components";
import { Box } from "@mui/material";
import TextArea from "components/atomics/TextArea";
import PLModal from "components/patternLib/PLModal";
import React from "react";
import translations from "translations";

interface EditCommentModalProps {
  commentValue: string;
  onCancelEdit: () => void;
  onChangeComment: (value: string) => void;
  onConfirmEdit: () => void;
  show: boolean;
}

const EditCommentModal: React.FC<EditCommentModalProps> = ({
  onCancelEdit,
  onConfirmEdit,
  show,
  onChangeComment,
  commentValue,
}) => {
  const handleChange = (event: PatternlibTextareaCustomEvent<LhChange>) => {
    const value = event.detail.value;
    onChangeComment(value as string);
  };
  return (
    <PLModal
      allowCloseOnBackdrop
      modalTitle={translations.pages.assetManagement.assetDetails.editComment}
      lhCancel={onCancelEdit}
      lhConfirm={onConfirmEdit}
      lhClose={onCancelEdit}
      show={show}
      iconName="edit"
    >
      <>
        <Box slot="modal-content">
          <TextArea
            maxlength={1200}
            value={commentValue}
            lhChange={handleChange}
            label={translations.globals.terms.comment}
            width="100%"
          />
        </Box>
      </>
    </PLModal>
  );
};
export default EditCommentModal;
